import '../App.css';
import React from 'react';
import { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams  } from "react-router-dom";

import { ethers } from "ethers"
import {
  useAddress,
  ConnectWallet,
} from "@thirdweb-dev/react";

function App() {
  

  const [searchParams] = useSearchParams();
  const getTx = useState(searchParams.get("tx"));


  useEffect(() => {
  document.getElementById("get-tx").href = "https://etherscan.io/tx/" + getTx[0];
  // document.getElementById("your-ape").innerHTML = "Ape #" + rotaTokenId;
}, []);

  /* global BigInt */

  const navigate = useNavigate();

  const [mintvalue, setMintValue] = useState('');
  const [voucher, setVoucher] = useState('');
  const [allowed, setAllowed] = useState('');
  const [addr, setAddress] = useState('');

  const [mintvalueReserved, setMintValueReserved] = useState('');
  const [mode, setMode] = useState('');

  const address = useAddress();

  useEffect(() => {

    if (address) {
      setAddress(address);
    }
  }, [address]);

    const previousAddressRef = useRef();
    useEffect(() => {
      previousAddressRef.current = address;
    }, [address]);
    const previousAddress = previousAddressRef.current;

    useEffect(() => {
      if (previousAddress && !address) {
        navigate("/");
      }
    }, [address, previousAddress]);


const rota = {
    address: "0xDfB29501b42f63A947Ddc5249F185D6BcBE6986f",
    abi: [
      "function balanceOf(address owner) public view virtual override returns (uint256)",
      "function ownerOf(uint256 tokenId) public view virtual override returns (address)"
    ]
};


const warbonds = {
  address: "0xcAcb0a5bb1f52F00a14bDA0dc85dE81392B2892B",
  abi: [
    "function balanceOf(address account, uint256 id) public view virtual override returns (uint256)"
  ]
};

const COST = 100000000000000;
const COST_ETH = 0.0001;
const PAYMENTFEE = 600000000000000;
const PAYMENTFEE_ETH = 0.0006;
const id = 1;

async function getStats(address) {

  const RPC = "https://eth-mainnet.g.alchemy.com/v2/hDbuktulZ87WrMhMeTlr6KdsttWlh2JJ";
  const provider = new ethers.providers.JsonRpcProvider(RPC);

  const CONTRACT_ADDRESS_ROTA = new ethers.Contract(rota.address, rota.abi, provider);
  const CONTRACT_ADDRESS_WARBONDS = new ethers.Contract(warbonds.address, warbonds.abi, provider);

  var rotaBal = await CONTRACT_ADDRESS_ROTA.balanceOf(address);
  var warbondsBal = await CONTRACT_ADDRESS_WARBONDS.balanceOf(address,1);

  document.getElementById("total-rota").innerHTML = rotaBal;
  document.getElementById("total-warbonds").innerHTML = warbondsBal;

  if(warbondsBal === 0){
    document.getElementById("war-deployment").classList.add("disabled-header");
  }
  else{
    document.getElementById("war-deployment").classList.remove("disabled-header");
  }

  if(rotaBal === 0){
    document.getElementById("war-deployment").classList.add("disabled-header");
  }
  else{
    document.getElementById("war-deployment").classList.remove("disabled-header");
  }
}

class transaction {
  constructor(contractAddress, chainId, signer) {
      this.contractAddress = contractAddress;
      this.chainId = chainId;
      this.signer = signer;
  }

  static async claim() {

      const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
      await provider.send("eth_requestAccounts", []);
      const signer = provider.getSigner();

      const connectedAddr = await signer.getAddress();

      const eth = await provider.getBalance(signer.getAddress());
      let ethbalance = parseInt(eth) / 1000000000000000000;

      if(ethbalance <=  PAYMENTFEE_ETH){
              document.getElementById("mint-button").innerHTML = "Insufficient Gas Funds"
              document.getElementById("mint-button").classList.add("disabled")
              document.getElementById("mint-button").style.color="black";
      }
              if(voucher === undefined){
              document.getElementById("mint-button").innerHTML = "Not on Allowlist"
              document.getElementById("mint-button").classList.add("disabled")
              document.getElementById("mint-button").style.color="black";
              }
              else{
                console.log(voucher);
                console.log(allowed);
                  // const hash = new ethers.Contract(contract.address, contract.abi, signer);
                  // const tx = await hash.claimTokensWithAllowlist(voucher, id, allowed);
                  document.getElementById("mint-button").classList.add("disabled")
                  document.getElementById("mint-button").innerHTML = "Claiming..."
                  document.getElementById("mint-button").style.color="black";
                  document.getElementById("mint-button").innerHTML = "Claiming..."
                  document.getElementById("mint-button").removeAttribute("onclick")
                  // await tx.wait();
                  document.getElementById("claimed").innerHTML = "Success!"
                  getStats(connectedAddr);
              }
      }

static async claim() {

      const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
      await provider.send("eth_requestAccounts", []);
      const signer = provider.getSigner();

      const connectedAddr = await signer.getAddress();

      const eth = await provider.getBalance(signer.getAddress());
      let ethbalance = parseInt(eth) / 1000000000000000000;

      if(ethbalance <=  PAYMENTFEE_ETH){
              document.getElementById("mint-button").innerHTML = "Insufficient Gas Funds"
              document.getElementById("mint-button").classList.add("disabled")
              document.getElementById("mint-button").style.color="black";
      }
              if(voucher === undefined){
              document.getElementById("mint-button").innerHTML = "Not on Allowlist"
              document.getElementById("mint-button").classList.add("disabled")
              document.getElementById("mint-button").style.color="black";
              }
              else{
                console.log(voucher);
                console.log(allowed);
                  // const hash = new ethers.Contract(contract.address, contract.abi, signer);
                  // const tx = await hash.claimTokensWithAllowlist(voucher, id, allowed);
                  document.getElementById("mint-button").classList.add("disabled")
                  document.getElementById("mint-button").innerHTML = "Claiming..."
                  document.getElementById("mint-button").style.color="black";
                  document.getElementById("mint-button").innerHTML = "Claiming..."
                  document.getElementById("mint-button").removeAttribute("onclick")
                  // await tx.wait();
                  document.getElementById("claimed").innerHTML = "Success!"
                  getStats(connectedAddr);
              }
      }

    }


    const  deploy = ()  => {
      navigate("/deploy")
    }

    const  view = ()  => {
      navigate("/view")
    }

    function delay(n) {
      return new Promise(function (resolve) {
        setTimeout(resolve, n * 500);
      });
    }

    const [rotaId, setRotaId] = useState('');

    const  send = async()   => {

      const RPC = "https://eth-mainnet.g.alchemy.com/v2/hDbuktulZ87WrMhMeTlr6KdsttWlh2JJ";
      const provider = new ethers.providers.JsonRpcProvider(RPC);
      try{
      const CONTRACT_ADDRESS_ROTA = new ethers.Contract(rota.address, rota.abi, provider);
    
      var owner = await CONTRACT_ADDRESS_ROTA.ownerOf(rotaId);


      if(owner === addr) {
          navigate("/confirm?rota=" + rotaId);
        }
        else{
          document.getElementById("select").value =  ""

          document.getElementById("select").placeholder  = "You do not own this ROTA";
        }
      }
      catch(e){
        document.getElementById("select").value =  ""
        document.getElementById("select").placeholder  = "You do not own this ROTA";
      }

    }

    const goBack = () => {
      navigate("/deploy?address=" + addr)
    }


  
  return (
  <main className="page-wrapper">

<header className="header navbar navbar-expand-lg bg-secondary shadow-sm shadow-dark-mode-none">
      <div className="container px-3">
        <a href="https://atsnft.io/" className="navbar-brand pe-3">
          <img src="ape.png" width={47} alt="Logo" />
        </a>
        <div id="navbarNav" className="offcanvas offcanvas-end">
          <div className="offcanvas-header border-bottom">
            <h5 className="offcanvas-title">Menu</h5>
            <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" />
          </div>
          <div className="offcanvas-body">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
                <a href="https://records.atsnft.io/" className="nav-link text-nowrap">Records</a>
              </li>
              <li className="nav-item">
              <a href="https://mint.atsnft.io/" className="nav-link text-nowrap" >Looking Glass</a>
              </li>
              <li className="nav-item">
              <a href="https://marketplace.atsnft.io/" target="_blank" className="nav-link text-nowrap">Marketplace</a>
              </li>
              <li className="nav-item">
              <a href="https://warbonds.atsnft.io/" className="nav-link text-nowrap">War Bonds</a>
              </li>
              <li className="nav-item">
              <a href="#" className="nav-link text-nowrap active" style={{color:"#e9ca7a"}}>War</a>
              </li>
              <li className="nav-item">
              <a href="https://records.atsnft.io/tickets" className="nav-link text-nowrap">Tickets</a>
              </li>
              <a href="https://twitter.com/ATSNFT" target="_blank" className="btn btn-icon btn-secondary btn-twitter d-none rounded-circle mx-1 d-lg-inline-flex"><i className="bx bxl-twitter"></i></a>
             <a href="https://discord.com/invite/ATSNFT" target="_blank" className="btn btn-icon btn-secondary btn-discord d-none rounded-circle mx-1 d-lg-inline-flex"><i className="bx bxl-discord"></i></a>
             
            </ul>
          </div>
          <div className="offcanvas-header border-top">
          <ConnectWallet
btnTitle="Log In"
      theme="dark"
    />
          </div>      
        </div> 

        <ConnectWallet
btnTitle="Log In"
      theme="dark"
    />
          <button type="button" className="navbar-toggler" data-bs-toggle="offcanvas" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon" />
        </button>
      </div>
    </header>

    <section id="module" className="mint-page-war" >
    <section className="container d-md-flex align-items-center justify-content-between pb-3 py-5">
       
       <nav className="container">


          <div className="d-flex justify-content-left" >
          <h4 >Success! Extraction attempt begins in 48 hrs!</h4>
          </div> 
          <br></br>

          <form className="input-group mb-4" style={{maxWidth: '100%'}} onSubmit={e => { send(e)}} >
          <a  type="button" id="get-tx" target="_blank" className="btn btn-info  btn-sm fs-sm rounded d-lg-inline-flexr" style={{marginRight:"10px"}} >See Transaction</a>
              <button type="button" className="btn btn-primary  bt n-sm fs-sm rounded d-lg-inline-flex"  onClick={goBack} >Continue</button>
          </form>

          <div className="d-flex justify-content-left pt-4 py-3 desktop" >
            <video controls loop className="container" id="Hero-Video" style={{borderRadius:"5px"}} name="media" playsInline="playsinline" muted="no" preload="yes" autoPlay="autoplay" data-setup='{"autoplay":"any"}'>
          <source id="Hero-Video--mp4" src="https://war-website-assets.s3.us-east-2.amazonaws.com/ATS+War+new+ending+v2.mp4" type="video/mp4"/>
            </video>

         </div>  

{/* 
         <div className="d-flex justify-content-left pt-4 py-3 mobile" >
            <img style={{borderRadius:"5px"}} src="ATS War new ending v2.gif"/>

         </div>   */}


       </nav>

     </section>
     </section>

</main>


  );
}

export default App;